import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID, makeStateKey } from '@angular/core';
import { Router } from '@angular/router';
import { RESPONSE } from '@uc/shared/authentication';
import { GraphQLErrorCode } from '@uc/web/shared/data-models';
import { Response } from 'express';

export const TS_NOT_FOUND_ERROR = makeStateKey<string>('ts-not-found-error');

@Injectable({ providedIn: 'root' })
export class NotFoundErrorHandlerService {
	constructor(
		@Optional() @Inject(RESPONSE) private _response: Response,
		@Inject(PLATFORM_ID) private _platformId: string,
		private _router: Router,
	) {}

	handleError(errorCode: any, isClearing = false) {
		const subPath = isClearing ? 'clearing' : 'degrees';
		if (isPlatformServer(this._platformId)) {
			if (
				errorCode === GraphQLErrorCode.UNI_COURSES_404 ||
				errorCode === GraphQLErrorCode.UNI_CLEARING_COURSES_404
			) {
				this._response?.status(404);
			}
		} else {
			this._router.navigate(['/courses', subPath], {
				queryParams: { uni: null },
				queryParamsHandling: 'merge',
			});
			setTimeout(() => location.reload(), 500);
		}
	}
}
